<template>
  <article id="stock-quote" v-if="getStockQuote.name">
    <div class="card-wrapper" id="card-wrapper">
      <PerformanceCard
        data-action="follow_stock"
        :item="this.getStockQuote"
        :performance-title="'ผลตอบแทน 1 ปี'"
        :performance-value="performanceYearPercentage"
        :perfNaN="perfNaN"
        :is-negative="Number(this.performanceYear) < 0"
        type="stock"
      />
    </div>
    <template v-if="currentType == 'stock'">
      <section id="section-graph">
        <GraphNav
          v-if="getStockQuote.name && showGraph"
          :id="getStockQuote.name"
          @call-tradingview="chartModalTV(getStockQuote.name)"
        />
      </section>

      <!-- modal TV -->
      <section id="stock-growthrate" class="container" v-if="growthRate">
        <div class="stock-wrapper">
          <FinancialCard
            :header="'สรุปการเติบโต'+currentHeaderQuarterOrYear"
            :sub-header="'(หน่วยล้านบาท)'"
            :share-function="openSharingModal"
            :capture-btn="false"
          >
            <TwoToggle slot="toggle" :select="toggleQorY" :select-function="toggleTimeData" />
            <TableOverflow
              v-if="growthRate && growthRateData"
              sectionID="stock-growthrate"
              :blur="false"
              slot="content"
              :stock-name="getStockQuote.name"
              :raw-data="growthRateData"
              :raw-name="'growthRate'"
              :emit-scrolling="true"
              :listen-scrolling="true"
              :capture-btn="false"
              :toggleQorY="toggleQorY"
              @finished="openChart"
            />
          </FinancialCard>
        </div>
      </section>
      <!-- สรุปการเติบโต 40 ไตรมาส-->
      <!-- สรุปการเงิน 40 ไตรมาส-->
      <section id="stock-financial-report" class="container" v-if="financialReport">
        <div class="stock-wrapper">
          <financial-card
            :header="'สรุปการเงิน'+currentHeaderQuarterOrYear"
            :sub-header="'(หน่วยล้านบาท)'"
            :share-function="openSharingModal"
            :capture-btn="false"
          >
            <two-toggle slot="toggle" :select="toggleQorY" :select-function="toggleTimeData" />
            <table-overflow
              sectionID="stock-financial-report"
              :blur="false"
              slot="content"
              :stock-name="getStockQuote.name"
              :raw-data="financialReportData"
              :raw-name="'financialReport'"
              :emit-scrolling="true"
              :listen-scrolling="true"
              :capture-btn="false"
              :toggleQorY="toggleQorY"
              @finished="openChart"
            />
          </financial-card>
        </div>
      </section>
      <!-- สรุปการเงิน 40 ไตรมาส-->
      <!-- อัตราส่วนทางการเงิน -->
      <section id="stock-financial-ratio" class="container" v-if="financialRatio">
        <div class="stock-wrapper">
          <financial-card
            :header="'อัตราส่วนทางการเงิน'"
            :sub-header="''"
            :share-function="openSharingModal"
            :capture-btn="false"
          >
            <two-toggle slot="toggle" :select="toggleQorY" :select-function="toggleTimeData" />
            <table-overflow
              sectionID="stock-financial-ratio"
              slot="content"
              :blur="false"
              :stock-name="getStockQuote.name"
              :raw-data="financialRatioData"
              :raw-name="'financialRatio'"
              :emit-scrolling="true"
              :listen-scrolling="true"
              :capture-btn="false"
              :toggleQorY="toggleQorY"
              @finished="openChart"
            />
          </financial-card>
        </div>
      </section>
      <!-- อัตราส่วนทางการเงิน -->
      <!-- สถิติสำคัญ -->
      <section id="stock-statistics" class="container" v-if="statistics">
        <div class="stock-wrapper">
          <financial-card
            :header="'สถิติสำคัญ'"
            :sub-header="''"
            :share-function="openSharingModal"
            :capture-btn="false"
          >
            <two-toggle slot="toggle" :select="toggleQorY" :select-function="toggleTimeData" />
            <table-overflow
              sectionID="stock-statistics"
              :blur="false"
              slot="content"
              :stock-name="getStockQuote.name"
              :raw-data="statisticsData"
              :raw-name="'statistics'"
              :emit-scrolling="true"
              :listen-scrolling="true"
              :capture-btn="false"
              :toggleQorY="toggleQorY"
              @finished="openChart"
            />
          </financial-card>
        </div>
      </section>
      <!-- สถิติสำคัญ -->
      <!-- ผู้ถือหุ้นรายใหญ่ -->
      <section id="stock-shareholder" class="container" v-if="getStockShareholder">
        <div class="stock-wrapper">
          <financial-card
            v-if="getStockQuote.name"
            :header="'ผู้ถือหุ้นรายใหญ่ '+getStockQuote.name || '...'"
            :share-function="openSharingModal"
            :capture-btn="false"
          >
            <TableShareholder
              :blur="false"
              slot="content"
              :list="getStockShareholder"
              :modal-function="openShareholderModal"
              :shareholderModal="shareholderModal"
            />
          </financial-card>
        </div>
      </section>
      <!-- ผู้ถือหุ้นรายใหญ่ -->
      <!-- กองที่ถือหุ้น -->
      <section id="stock-shareholder" class="container">
        <div class="stock-wrapper">
          <FundCard
            v-if="getStockFundQuote.fund_list"
            :header="fundListHeader"
            :fund-list="getStockFundQuote.fund_list"
            :unhide-lengthy-fund-fn="toggleLengthyFund"
            :hide-lengthy-fund="hideLenthyFund"
          />
        </div>
      </section>
      <!-- กองที่ถือหุ้น -->
    </template>
    <shareholder-modal
      v-if="shareholderModal"
      :close-function="closeShareholderModal"
      :all-shareholder-data="getStockShareholder"
      :initial-shareholder-index="shareholderIndex"
      :stock-price="stockPrice"
      :redirect-function="redirectFromShareholderModal"
    />
  </article>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PerformanceCard from "../../../components/miniapp/global/PerformanceCard";
import FinancialCard from "../../../components/miniapp/stock-quote/FinancialCard";
import TwoToggle from "../../../components/miniapp/stock-quote/TwoToggle";
import TableOverflow from "../../../components/miniapp/stock-quote/TableOverflow";
import TableShareholder from "../../../components/miniapp/stock-quote/TableShareholder";
import shareholderModal from "../../../components/miniapp/stock-quote/ShareholderModal";
import FundCard from "../../../components/miniapp/stock-quote/FundCard";
import GraphNav from "../../../components/miniapp/stock-quote/GraphNav";
import { updateQueryString } from "../../../utils/stock";
const { obj } = require("./data");

export default {
  metaInfo() {
    return {
      title: process.env.VUE_APP_NAME
    };
  },
  components: {
    PerformanceCard,
    FinancialCard,
    TwoToggle,
    TableOverflow,
    TableShareholder,
    shareholderModal,
    FundCard,
    GraphNav
  },
  computed: {
    ...mapGetters("stock", [
      "getStockQuote",
      "getStockPeriod",
      "showChartModal",
      "getStockShareholder",
      "getStockFundQuote",
      "getChartData"
    ]),
    stockPrice() {
      return Number(this.getStockQuote.price);
    },
    performanceYearPercentage() {
      if (!isNaN(parseFloat(this.performanceYear)) && isFinite(this.performanceYear)) {
        this.perfNaN = false;
        return this.performanceYear >= 0
          ? "+" + Number(this.performanceYear).toFixed(2) + " %"
          : Number(this.performanceYear).toFixed(2) + " %";
      } else {
        return "N/A";
      }
    },
    currentHeaderQuarterOrYear() {
      return this.toggleQorY == 1 ? " 40 ไตรมาส" : " 10 ปี";
    },
    fundListHeader() {
      return (
        "กองทุน " +
        this.getStockFundQuote.fund_list.length +
        " กองที่ถือหุ้น " +
        this.getStockQuote.name
      );
    },
    growthRate() {
      this.growthRateData = this.$store.getters["stock/getFinancialCardByCardName"]({
        securityID: this.getStockQuote.ID,
        fields: obj.growthRate
      });
      return this.growthRateData;
    },
    financialReport() {
      this.financialReportData = this.$store.getters["stock/getFinancialCardByCardName"]({
        securityID: this.getStockQuote.ID,
        fields: obj.financialReport
      });
      return this.financialReportData;
    },
    financialRatio() {
      this.financialRatioData = this.$store.getters["stock/getFinancialCardByCardName"]({
        securityID: this.getStockQuote.ID,
        fields: obj.financialRatio
      });
      return this.financialRatioData;
    },
    statistics() {
      this.statisticsData = this.$store.getters["stock/getFinancialCardByCardName"]({
        securityID: this.getStockQuote.ID,
        fields: obj.statistics
      });
      return this.statisticsData;
    },
    currentType() {
      let type = Math.sign(this.getStockQuote.ID) === -1 ? "index" : "stock";
      return type;
    }
  },
  props: {
    performanceTitle: {
      type: String,
      default: "ผลตอบแทน"
    },
    performanceValue: {
      type: String,
      default: "0.00 %"
    },
    isNegative: {
      type: Boolean,
      default: false
    },

    shareFunction: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      showGraph: false,
      hideLenthyFund: true,
      quote: null,
      firstSight: true,
      perfNaN: true,
      sharingModal: false,
      toggleQorY: 1,
      shareholderModal: false,
      shareholderIndex: 0,
      showChartCover: true,
      isModal: false,
      growthRateData: null,
      financialReportData: null,
      financialRatioData: null,
      statisticsData: null,
      startYear: null,
      performanceYear: {
        performance: 0,
        range: "year"
      },
      sharingPath: "ggwp.com" //
    };
  },
  async created() {
    this.quote = await this.findStockQuote(this.$route.query.name);
    let rs = await this.findStockGraphPeriod(this.getStockQuote.ID)
    this.showGraph = rs && this.getStockPeriod.default_period ? true : false
    this.performanceYear = this.getStockQuote["perfYear"];
    let currentDate = new Date();
    currentDate.setYear(currentDate.getFullYear() - 10);
    this.startYear = currentDate.getFullYear();
    this.findStockBySecurityID({
      securityID: this.getStockQuote.ID,
      fiscal: this.startYear
    });
  },
  async mounted() {
    await this.findFundQuote(this.getStockQuote.name || this.$route.query.name);
    if (this.getStockQuote.ID) {
      await this.findShareHolder(this.getStockQuote.ID);
    }
  },
  watch: {
    async getStockQuote() {
      await this.findFundQuote(this.getStockQuote.name || this.$route.query.name);
      if (this.getStockQuote.ID) {
        await this.findShareHolder(this.getStockQuote.ID);
      }
    },
    async getStockFundQuote() {
      return this.getStockFundQuote;
    },
    async stockShareholder() {
      return this.stockShareholder;
    },
    async showChartModal() {
      return this.showChartModal;
    },
    $route: async function(newRoute, oldRoute) {
      this.showGraph = false
      this.quote = await this.findStockQuote(newRoute.query.name);
      let rs = await this.findStockGraphPeriod(this.getStockQuote.ID)
      this.showGraph = rs && this.getStockPeriod.default_period ? true : false
      this.findStockBySecurityID({
        securityID: this.getStockQuote.ID,
        fiscal: this.startYear
      });
    }
  },
  methods: {
    ...mapActions("stock", [
      "findStockQuote",
      "findStockGraphPeriod",
      "findStockBySecurityID",
      "closeChartModal",
      "findShareHolder",
      "findFundQuote"
    ]),
    toggleChartCover() {
      this.showChartCover = !this.showChartCover;
    },
    closeSharingModal() {
      this.sharingModal = false;
    },
    openSharingModal() {
      this.sharingModal = true;
    },
    toggleTimeData(index) {
      this.toggleQorY = index;
      // TODO : use when press share and copy link , 2 conition to handle when toggle
      this.sharingPath = updateQueryString(
        this.sharingPath,
        "timeframe",
        index === 1 ? "quarter" : "year"
      );
    },
    // openChart(e) {
    openChart() {
      if (this.firstSight) {
        if (this.$route.query.chart) {
          if (document.getElementById(this.$route.query.chart)) {
            document.getElementById(this.$route.query.chart).click();
            this.firstSight = false;

            // $("html, body").animate(
            //   {
            //     scrollTop: $("#" + this.$route.query.chart).offset().top
            //   },
            //   500
            // );
          }
        }
      }
    },
    openShareholderModal(index) {
      this.shareholderModal = true;
      this.shareholderIndex = index;
      // document.body.style.overflowY = "hidden";
    },
    closeShareholderModal() {
      this.shareholderModal = false;
      document.body.style.overflowY = "initial";
    },
    redirectFromShareholderModal(elem) {
      if (typeof elem === "object" && "name" in elem) {
        return `/stock/${elem.name}`;
      } else {
        return `/stock/${encodeURIComponent(elem)}`;
      }
      // document.body.style.overflowY = "initial";
    },
    closeModalChart() {
      this.closeChartModal;
    },

    toggleLengthyFund() {
      this.hideLenthyFund = !this.hideLenthyFund;
    },
    chartModalTV(short_code) {
      this.$router.push({
        name: "miniapp-tradingview",
        query: { name: short_code, type: "stock" }
      });
    }
  }
};
</script>

<style lang='scss' scoped>
.stock-growthrate {
  @extend %container-style;
}
#card-wrapper {
  @extend %container-style;
}
#stock-trading-view {
  margin-bottom: 50px;
}
#section-graph {
  margin-bottom: 50px;
  .graph-ctn {
    @include finCol(12, 12, 0px, middle, true, true);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    .ctn-graph-professional {
      @include finRippleBtn(#f4f4f4, #f4f4f4, $color-normal-text);
      @extend %font-size-ss;
      padding: 5px 19px;
      text-decoration: none;
      font-weight: bold;
      border-radius: 4px;
      i {
        margin-right: 10px;
      }
    }
  }
  .stock-chart-modal {
    h3 {
      float: left;
      @extend %font-size-s;
    }
    #modal-fund-tradingview {
      position: absolute;
      width: 100%;
      top: 43px;
    }
    @media screen and (min-width: 320px) and (max-width: 767px) and (orientation: portrait) {
      #modal-fund-tradingview {
        transform: rotate(90deg);
        transform-origin: right top;
        width: 100vh;
        overflow-x: hidden;
        position: absolute;
        top: 100%;
        right: 52px;
      }
    }
  }
}
</style>